var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashCapSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 5L18.7995 5C19.9196 5 20.4797 5 20.9075 5.21799C21.2838 5.40973 21.5898 5.7157 21.7815 6.09202C21.9995 6.51984 21.9995 7.0799 21.9995 8.2V15.8C21.9995 16.9201 21.9995 17.4802 21.7815 17.908C21.5898 18.2843 21.2838 18.5903 20.9075 18.782C20.4797 19 19.9196 19 18.7995 19L1.99976 19M1.99976 12H12.9995M14.5998 14H15.3998C15.9598 14 16.2398 14 16.4537 13.891C16.6419 13.7951 16.7949 13.6422 16.8908 13.454C16.9998 13.2401 16.9998 12.9601 16.9998 12.4V11.6C16.9998 11.0399 16.9998 10.7599 16.8908 10.546C16.7949 10.3578 16.6419 10.2049 16.4537 10.109C16.2398 10 15.9598 10 15.3998 10H14.5998C14.0397 10 13.7597 10 13.5458 10.109C13.3576 10.2049 13.2046 10.3578 13.1087 10.546C12.9998 10.7599 12.9998 11.0399 12.9998 11.6V12.4C12.9998 12.9601 12.9998 13.2401 13.1087 13.454C13.2046 13.6422 13.3576 13.7951 13.5458 13.891C13.7597 14 14.0397 14 14.5998 14Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashCapSquare);
export default __webpack_public_path__ + "static/media/dash-cap-square.d1c3722d6b1cf14c263c5e29c871722f.svg";
export { ForwardRef as ReactComponent };